import { BENCH_SLAT_GAP_MM, benchSlatCount } from "./constants";
import type { BenchRun } from "./types";

/** Equal-width seat boards, fitted to depth; authored gaps buy 90 mm stock for ripping. */
export function resolveBenchSlats(
	run: Pick<BenchRun, "depthMm" | "slatGapMm">,
) {
	const count = benchSlatCount(run.depthMm, run.slatGapMm);
	const gapMm =
		run.slatGapMm ?? Math.min(BENCH_SLAT_GAP_MM, run.depthMm * 0.08);
	const widthMm = (run.depthMm - gapMm * (count - 1)) / count;
	return { count, gapMm, widthMm };
}
